import getConfig from 'next/config';

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

export const CmsImageURL = publicRuntimeConfig.strapiUrl;

// add CMS collections here
export enum CmsCollections {
  heroBanner = 'hero-banner',
  dashboardBanners = 'dashboard-banners',
  footerDetails = 'footer-details',
}

export enum CmsFieldNames {
  DASHBOARD_BANNER_AFFINITY_CODE_FIELD = 'affinityCode',
  FOOTER_AFFINITY_CODE_FIELD = 'affinityCode',
}

export const CmsClientConfig = {
  baseURL: `${publicRuntimeConfig.strapiUrl}/api`,
  headers: {
    Authorization: `bearer ${serverRuntimeConfig.strapiApiToken}`,
  },
};
